/**
 * Output charting entry (Phase 18 M8): urine, stool, emesis, drainage, diapers.
 */

import { BaseEntryData } from './chart-entry.dto';

export const OUTPUT_TYPES = ['URINE', 'STOOL', 'EMESIS', 'DRAINAGE', 'DIAPER', 'OTHER'] as const;
export type OutputType = typeof OUTPUT_TYPES[number];

export interface OutputData extends BaseEntryData {
  outputType: OutputType;
  /** 0–5000 */
  volumeMl?: number;
  /** 0–50 */
  diaperCount?: number;
  characteristics?: string;
  notes?: string;
}
